import React from 'react';
import _ from 'lodash';

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import Loader from '../../Components/Loader';

import UmlaufplanMini from '../Umlaufplaene/Mini';
import UmlaufplanAuswahl from '../Umlaufplaene/Auswahl';

import LoaderButton from '../../Components/LoaderButton';

import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux'
import { doPost, doLoad, doPut, select, doDelete, apiUrlOpen } from '../../Redux/Actions'
import store from '../../Redux';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';

import { TextFieldHelper, SelectFieldWrapper } from '../../Components/Fields';

import AddIcon from '@material-ui/icons/Add';
import PrintIcon from '@material-ui/icons/Print';
import PdfIcon from '@material-ui/icons/PictureAsPdf';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import LinearProgress from '@material-ui/core/LinearProgress';
//import MenuItem from '@material-ui/core/MenuItem';

import RAW_Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import MenuItem_RAW from '@material-ui/core/MenuItem';
import Select_RAW from '@material-ui/core/Select';

import convertMinutesToString from '../../Components/convertMinutesToString';

import { ColumnHeaderCell, EditableCell, Cell, Column, Table } from "@blueprintjs/table";
import { ContextMenuTarget, Menu, MenuItem, Divider } from "@blueprintjs/core";
import { Omnibar } from "@blueprintjs/select";

import { HotKeys } from 'react-hotkeys';
import DatePickerContainer from '../../Components/DatePickerContainer';
import ButtonGroup from '../../Components/ButtonGroup';


import moment from 'moment'
import 'moment/locale/de'
moment.locale("de");

const ENDPOINT = "dienst"

const styles = theme => ({

})

const columns = [
    "Name"
];


class Dienstplan extends Master {

    state = {
        kalender: 0,
        dienste: 0,
        daysArray: {},
        mitarbeiter: {},
        kalender: {}
    }

    shouldComponentUpdate(nextProps, nextState) {
        var doReturn = false
        if(nextProps.mitarbeiter !== nextState.mitarbeiter) {
            doReturn = true
            this.state.mitarbeiter = nextProps.mitarbeiter
        }
        if(nextProps.daysArray !== nextState.daysArray) {
            doReturn = true
            this.state.daysArray = nextProps.daysArray
        }
        if(nextProps.dateArray !== nextState.dateArray) {
            doReturn = true
            this.state.dateArray = nextProps.dateArray
        }
        if(nextProps.weekArray !== nextState.weekArray) {
            doReturn = true
            this.state.weekArray = nextProps.weekArray
        }
        if(nextProps.kalender !== this.state.kalender) {
            doReturn = true
            this.state.kalender = nextProps.kalender
        }
        if(nextProps.dienste !== this.state.dienste) {
            doReturn = true
            this.state.dienste = nextProps.dienste
        }
        if(
            nextProps.doFocus !== undefined
            && nextProps.doFocus === false
            && nextProps.doFocus !== nextState.doFocus
        ) {
            this.state.doFocus = nextProps.doFocus
            this.state.focusedCell = nextState.focusedCell
            doReturn = true
        }
        if(nextProps.sortierung !== nextState.sortierung) {
            this.state.sortierung = nextProps.sortierung
            doReturn = true
        }
        if(nextProps.umlaufplaeneAktiv !== nextState.umlaufplaeneAktiv) {
            this.state.umlaufplaeneAktiv = nextProps.umlaufplaeneAktiv
            doReturn = true
        }
        if(nextProps.kwZeit !== nextState.kwZeit) {
            this.state.kwZeit = nextProps.kwZeit
            doReturn = true
        }
        if(nextProps.dienstplanBusnummer !== nextState.dienstplanBusnummer) {
            this.state.dienstplanBusnummer = nextProps.dienstplanBusnummer
            doReturn = true
        }

        this.state.doFocus = nextProps.doFocus
        return doReturn
    }

    componentDidMount() {
        document.title = "Leitstand"
    }

    focusedCell = (cell) => {
        this.props.selectedCell(cell)
        this.setState({focusedCell: cell})
    }

    onSelection = (selectedRegions) => {
        if(selectedRegions[0].cols === undefined) {
            this.props.selectedFields({
                col_f: selectedRegions[0].rows[0],
                col_t: selectedRegions[0].rows[1],
                row: selectedRegions[0].rows[0]
            })
            return
        }
        this.props.selectedFields({
            col_f: selectedRegions[0].cols[0],
            col_t: selectedRegions[0].cols[1],
            row: selectedRegions[0].rows[0]
        })
    }

    render() {

        var {
            contextMenu, widths, mitarbeiter, renderColumnHeaderMitarbeiter, renderColumnHeaderZeit, renderColumnHeaderWeek, cellRendererWeek, daysArray, renderColumnHeader, cellRenderer, cellRendererZeit, weekArray
        } = this.props

        var heights = new Array(mitarbeiter.data.length).fill(23)
        heights.push(20)
        heights.push(20)
        heights.push(20)

        if(widths.length < 10) {
            return <span />
        }

        return (
                <div className="dienstplanTable">

                    <Table
                        getCellClipboardData={this.props.getSingleData}
                        bodyContextMenuRenderer={contextMenu}
                        columnWidths={widths}
                        rowHeights={heights}
                        defaultColumnWidth={15}
                        defaultRowHeight={23}
                        numRows={heights.length}
                        onRowsReordered={this.props.onRowsReordered}
                        enableRowReordering={true}
                        enableFocusedCell
                        enableRowResizing={false}
                        enableColumnResizing={false}
                        numFrozenColumns={1}
                        enableGhostCells={false}
                        renderMode={"none"}
                        onFocusedCell={this.focusedCell}
                        onSelection={this.onSelection}
                    >
                        
                        <Column
                            name="Mitarbeiter"
                            columnHeaderCellRenderer={renderColumnHeaderMitarbeiter}
                            cellRenderer={cellRenderer}
                        />

                        {daysArray.map((day) => (
                            <Column
                                name={day}
                                columnHeaderCellRenderer={renderColumnHeader}
                                cellRenderer={cellRenderer}
                            />
                        ))}

                        <Column
                            name="Busnummer"
                            columnHeaderCellRenderer={renderColumnHeaderZeit}
                            cellRenderer={cellRendererZeit}
                        />

                        <Column
                            name="Stunden AZ"
                            columnHeaderCellRenderer={renderColumnHeaderZeit}
                            cellRenderer={cellRendererZeit}
                        />

                        <Column
                            name="Stunden AZ Gesamt"
                            columnHeaderCellRenderer={renderColumnHeaderZeit}
                            cellRenderer={cellRendererZeit}
                        />

                        <Column
                            name="Anzahl"
                            columnHeaderCellRenderer={renderColumnHeaderZeit}
                            cellRenderer={cellRendererZeit}
                        />

                        {weekArray.map((week) => (
                            <Column 
                                columnHeaderCellRenderer={renderColumnHeaderWeek}
                                cellRenderer={cellRendererWeek}
                            />
                        ))}

                    </Table>
                </div>
        )
    }

}

const map = {
    'deleteNode': ["del", "alt+backspace"]
}

class ListObject extends Master {

    state = {

        ...this.state,
        isLoading: true,
        putLoading: false,
        dialogOpen: false,
        newEntry: {},
        route: "/" + ENDPOINT,

        startDate: moment().startOf('month'),
        endDate: moment().endOf('month'),

        currentMonth: moment().toDate(),
        tmpMonth: moment(),

        daysArray: [],
        dateArray: [],
        weekArray: [],

        entries: [],
        isLoadingArray: {},
        dienste: {},

        _focusedCell: {},

        nettoZeit: {},
        nettoZeitGesamt: {},
        kwZeit: {},

        stat_diensteSoll: {},
        stat_diensteIst: {},

        borderBold: undefined,

        anmerkung_dienst: undefined,
        anmerkung_show: false,
        anmerkung_text: "",

        copyData: [],

        dienstplanAuswahl: ""

    }

    componentDidMount() {

        //this.props.doLoad()
        this.props.parameter_doLoad()
        this.props.besondererDienst_doLoad()
        //this.props.mitarbeiter_doLoad()
        this.calcDays()

        this.unsubscribe = store.subscribe(() => {

                var generic = select(store.getState(), "leitstandSortierung")
                if(generic.data.leitstand_attribute && this.state.newEntry !== generic.data.leitstand_attribute) {
                    this.state.newEntry = generic.data.leitstand_attribute
                }
                
                var generic = select(store.getState(), ENDPOINT)
                
                this.state.dienste = {}
                //if(this.generic != generic.data.length) {
                    this.state.stat_diensteIst = {}
                    this.state.stat_diensteSoll = {}
                    this.state.nettoZeit = {}
                    this.state.nettoZeitGesamt = {}
                    this.state.kwZeit = {}
                    this.state.diensteAnzahl = {}
                    this.generic = generic.data.length

                    generic.data.forEach((dienst) => {

                        var date = moment(dienst.datum).format("dd,DD")
                        var week = moment(dienst.datum).format("w")

                        if(this.state.dienste[dienst.mitarbeiter] === undefined) {
                            this.state.dienste[dienst.mitarbeiter] = {}
                        }

                        if(this.state.kwZeit[dienst.mitarbeiter] === undefined) {
                            this.state.kwZeit[dienst.mitarbeiter] = {}
                        }

                        if(this.state.kwZeit[dienst.mitarbeiter][week] === undefined) {
                            this.state.kwZeit[dienst.mitarbeiter][week] = 0
                        }

                        if(!this.state.stat_diensteIst[date]) {
                            this.state.stat_diensteIst[date] = parseFloat(0)
                        }

                        if(!this.state.nettoZeit[dienst.mitarbeiter]) {
                            this.state.nettoZeit[dienst.mitarbeiter] = parseFloat(0)
                        }

                        if(!this.state.nettoZeitGesamt[dienst.mitarbeiter]) {
                            this.state.nettoZeitGesamt[dienst.mitarbeiter] = parseFloat(0)
                        }

                        if(!this.state.diensteAnzahl[dienst.mitarbeiter]) {
                            this.state.diensteAnzahl[dienst.mitarbeiter] = 0
                        }

                        var stunden = undefined

                        var uSdone = false
                        if(
                            dienst.umlaufplan &&
                            dienst.umlaufplan.netto_zeit &&
                            (
                                dienst.umlaufplan.stunden_nicht_relevant === undefined ||
                                dienst.umlaufplan.stunden_nicht_relevant === false
                            )
                        ) {
                            this.state.nettoZeit[dienst.mitarbeiter] += parseFloat(dienst.zeit_netto_zeit)
                            stunden = convertMinutesToString(dienst.zeit_netto_zeit)
                            this.state.kwZeit[dienst.mitarbeiter][week] += dienst.zeit_netto_zeit
                            this.state.diensteAnzahl[dienst.mitarbeiter] += 1
                            uSdone = true
                        }

                        if(
                            dienst.umlaufplan &&
                            dienst.umlaufplan.netto_zeit &&
                            dienst.umlaufplan.stunden_nicht_relevant === true &&
                            dienst.ok &&
                            uSdone === false
                        ) {
                            this.state.nettoZeit[dienst.mitarbeiter] += parseFloat(dienst.zeit_netto_zeit)
                            stunden = convertMinutesToString(dienst.zeit_netto_zeit)
                            this.state.kwZeit[dienst.mitarbeiter][week] += dienst.zeit_netto_zeit
                            this.state.diensteAnzahl[dienst.mitarbeiter] += 1
                        }

                        if(dienst.umlaufplan && dienst.umlaufplan.netto_zeit) {
                            this.state.nettoZeitGesamt[dienst.mitarbeiter] += parseFloat(dienst.zeit_netto_zeit)
                        }

                        if(dienst.umlaufplan && dienst.zeit_netto_zeit) {
                            stunden = convertMinutesToString(dienst.umlaufplan.netto_zeit)
                        }

                        if(dienst.umlaufplan.id) {
                            this.state.stat_diensteIst[date] += 1 
                        }

                        if(
                            dienst.besonderer_dienst && 
                            dienst.besonderer_dienst.id && 
                            dienst.besonderer_dienst.stunden && 
                            dienst.besonderer_dienst.leistand === undefined
                        ) {

                            var minutenBesondererDienst = parseFloat(dienst.besonderer_dienst.stunden) * 60
                            stunden = convertMinutesToString(minutenBesondererDienst)

                            this.state.nettoZeit[dienst.mitarbeiter] += parseFloat(dienst.besonderer_dienst.stunden) * 60
                            this.state.nettoZeitGesamt[dienst.mitarbeiter] += parseFloat(dienst.besonderer_dienst.stunden) * 60

                            if(dienst.besonderer_dienst.kuerzel.toLowerCase() != "ft") {
                                this.state.kwZeit[dienst.mitarbeiter][week] += minutenBesondererDienst
                            }

                            if((dienst.besonderer_dienst.stunden && dienst.besonderer_dienst.stunden > 0)
                                && dienst.besonderer_dienst.kuerzel.toLowerCase() != "ft"
                                && dienst.besonderer_dienst.leitstand === undefined
                            ) {
                                this.state.stat_diensteIst[date] += 1
                                this.state.diensteAnzahl[dienst.mitarbeiter] += 1
                            }

                        }

                        if(dienst.besonderer_dienst
                            && dienst.besonderer_dienst.name
                            && dienst.besonderer_dienst.name.toLowerCase() === "n"
                            && dienst.besonderer_dienst.leitstand === undefined
                        ) {
                            this.state.stat_diensteIst[date] += 1
                            this.state.diensteAnzahl[dienst.mitarbeiter] += 1
                        }

                        var textFarbe = "#000"
                        if(dienst.umlaufplan && dienst.umlaufplan.farbzuordnung_single) {
                            textFarbe = dienst.umlaufplan.farbzuordnung_single.text
                        }

                        var date = moment(dienst.datum).format("dd,DD")
                        var kuerzel = dienst.umlaufplan.kuerzel
                        if(dienst.besonderer_dienst && dienst.besonderer_dienst.kuerzel) {
                            kuerzel = dienst.besonderer_dienst.kuerzel
                        }

                        this.state.dienste[dienst.mitarbeiter][date] = {
                            datum: dienst.datum,
                            mitarbeiter: dienst.mitarbeiter,
                            name: "OK",
                            paket: dienst.umlaufplan.paket,
                            kuerzel: kuerzel,
                            kuerzel_bus: dienst.umlaufplan.kuerzel_bus,
                            name: dienst.umlaufplan.kuerzel_bus ? dienst.umlaufplan.kuerzel_bus : dienst.name,
                            raw_name: dienst.umlaufplan && dienst.umlaufplan.name,
                            start: dienst.umlaufplan.start,
                            ende: convertMinutesToString(dienst.umlaufplan.ende_raw, true),
                            farbe: dienst.umlaufplan.farbe ? dienst.umlaufplan.farbe : dienst.besonderer_dienst.farbe,
                            textFarbe: textFarbe,
                            umlaufplan: dienst.umlaufplan.id,
                            besonderer_dienst: dienst.besonderer_dienst.id,
                            ist_feiertag: dienst.ist_feiertag,
                            ist_kalender: dienst.ist_kalender,
                            id: dienst.id,
                            isLoading: false,
                            date: date,
                            stunden: stunden,
                            kommentar: dienst.kommentar,
                            ist_start: dienst.zeit_beginn,
                            ist_ende: dienst.zeit_ende,
                            ist_stunden: dienst.zeit_netto_zeit,
                        }

                    })

                    this.setState({})
                //}

                if(this.state.isLoading) {
                    this.setState({
                        isLoading: generic.isLoading
                    })
                }

                if(_.has(generic, "dialogOpen") && this.state.dialogOpen !== generic.dialogOpen) {
                    this.setState({
                        dialogOpen: generic.dialogOpen
                    })
                }

            }
                
        )
        
    }

    calcDays = () => {

        var {
            startDate, endDate, daysArray, dateArray, weekArray
        } = this.state

        var days = moment.duration(moment(moment(endDate).hour(23)).diff(moment(moment(startDate).hour(1)))).asDays();
 
        var i = -1

        daysArray = []
        dateArray = []

        while (i < Math.ceil(days)) {
            daysArray.push(moment(startDate).add(i, 'days').format("dd,DD"))
            dateArray.push(moment(startDate).add(i, 'days').toDate())
            i++;
        }

        weekArray = []
        var startDateTmp = moment(startDate.toDate())
        while (startDateTmp <= endDate) {
            weekArray.push(moment(startDateTmp).format("ww"))
            startDateTmp.add(1, 'weeks')
        }

        if(startDate.format("MM") === "02") {
            weekArray.push(moment(startDateTmp).format("ww"))
        }

        this.setState({
            daysArray: daysArray,
            dateArray: dateArray,
            weekArray: weekArray
        })

        var d = endDate.toDate()
        var monat = d.getMonth() + 1
        var jahr = d.getFullYear()

        this.props.doLoad({von: startDate.format("YYYY-MM-DD"), bis: endDate.format("YYYY-MM-DD")})
        this.props.mitarbeiter_doLoad({
            _von: startDate.format("YYYY-MM-DD"),
            _bis: endDate.format("YYYY-MM-DD"),
            monat: monat,
            jahr: jahr
        })

        this.props.leitstandSortierung_doLoad({jahr: jahr, monat: monat})

    }

    new_changeDate = name => date => {
        this.state[name] = date
        this.calcDays()
    }

    handleRangeChange = (date) => {
        this.state.startDate = date[0]
        this.state.endDate = date[1]
        this.calcDays()
    }

    cell_setValue = (columnIndex) => {
        if(this.state.entries[columnIndex] === undefined) {
            this.state.entries[columnIndex] = {}
        }
    }

    cell_onChange = (value, rowIndex, columnIndex) => {

        this.state._focusedCell = {
            col: columnIndex,
            row: rowIndex,
            focusSelectionIndex: 0
        }

        if(value !== " " && (isNaN(parseInt(value)) || parseInt(value) === 0)) {
            return
        }

        if(value === " ") {
            value = "*"
        }

        this.cell_setValue(columnIndex)

        /*this.state.entries[columnIndex][rowIndex] = {
            kuerzel: "",
            farbe: ""
        }*/

        this.state.rowIndex = rowIndex
        this.state.columnIndex = columnIndex
        this.state.umlaufplan = value
        this.state.datum = this.state.dateArray[columnIndex-1]
        this.state.dialogOpen_umlaufplan = true
        this.state.query = value

        this.setState({})

        return ""

    }

    selectUmlaufplan = (umlaufplan) => {
        if(typeof umlaufplan !== 'object') {
            return
        }
        var rowIndex = this.state.rowIndex
        var columnIndex = this.state.columnIndex
        var mitarbeiter = this.props.mitarbeiter.data[rowIndex]
        if(mitarbeiter===undefined) return

        var startDate = moment(this.state.dateArray[columnIndex]).format("dd,DD")
    
        if(this.state.dienste[mitarbeiter.id]) {
            var _dienst = this.state.dienste[mitarbeiter.id][startDate]
            if(_dienst && _dienst.id) {
                this.props.deleteDienst(_dienst.id) 
            }
        }
        
        this.props.postDienst({
            umlaufplan: umlaufplan,
            datum: this.state.dateArray[columnIndex],
            mitarbeiter: mitarbeiter.id,
        })
    }

    cell_onConfirm_Busnummer = (value, id, row) => {
        var data = {
            jahr: parseInt(this.state.startDate.format("YYYY")),
            monat: parseInt(this.state.startDate.format("MM")),
            mitarbeiter_id: id,
            wert: value
        }

        var exists = false
        if(this.props.leitstandSortierung.data.dienstplan_busnummer) {
            this.props.leitstandSortierung.data.dienstplan_busnummer.forEach((item, k) => {
                if(item.mitarbeiter_id === id) {
                    this.props.leitstandSortierung.data.dienstplan_busnummer[k].wert = value + ""
                    exists = true
                }
            })
        } else {
            this.props.leitstandSortierung.data.dienstplan_busnummer = []
            this.props.leitstandSortierung.data.dienstplan_busnummer.push(data)
            exists = true
        }

        if(!exists) {
            this.props.leitstandSortierung.data.dienstplan_busnummer.push(data)
        }
        
        console.log("data", data, this.props.leitstandSortierung.data.dienstplan_busnummer)

        this.props.dienstplanBusnummer(data)
    }

    cell_onConfirm_SOLL = (value, col) => {
        this.props.leitstandSortierung.data.umlaufplaene_aktiv.forEach((day, k) => {
            if(moment(day.datum).format("DD-MM-YYYY") === moment(this.state.dateArray[col]).format("DD-MM-YYYY")) {
                this.props.leitstandSortierung.data.umlaufplaene_aktiv[k].wert = value + ""
            }
        })
        this.props.dienstplanSoll({
            datum: moment(this.state.dateArray[col]).add(5, "hours"),
            wert: value
        })
    }

    cell_onConfirm = (value, rowIndex, columnIndex) => {

        var bD_selected = undefined
        this.props.besondererDienst.data.forEach((item) => {
            if((item.kuerzel+"").toLowerCase() === (value+"").toLowerCase()) {
                bD_selected = item
            }
        })

        if(bD_selected === undefined) {
            return ""
        }

        var mitarbeiter = this.props.mitarbeiter.data[rowIndex]
        if(mitarbeiter===undefined) return

        var dienst = {
            besonderer_dienst: bD_selected,
            datum: this.state.dateArray[columnIndex],
            mitarbeiter: mitarbeiter.id
        }

        this.props.postDienst(dienst)

        this.setState({})

    }

    getValue = (column, row) => {
        var mitarbeiter = this.props.mitarbeiter.data[row]
        if(mitarbeiter !== undefined) {
            var day = this.state.daysArray[column]
            if(this.state.dienste[mitarbeiter.id] !== undefined) {
                if(this.state.dienste[mitarbeiter.id][day] !== undefined) {
                    return this.state.dienste[mitarbeiter.id][day]
                }
                if(this.state.entries[column] !== undefined) {
                    if(this.state.entries[column][row] !== undefined) {
                        return this.state.entries[column][row]
                    }
                }
            }
        }
        return ""
    }

    setLoading = (column, row) => {
        if(this.state.isLoadingArray[column] === undefined) {
            this.state.isLoadingArray[column] = {}
        }
    }

    isLoading = (column, row) => {
        if(this.state.isLoadingArray[column] === undefined) {
            return false
        }
        return this.state.isLoadingArray[column][row]
    }

    deleteItem = (column, row) => {

        if(this.props.mitarbeiter.data.length + 2 === row) {
            this.props.leitstandSortierung.data.umlaufplaene_aktiv.forEach((day, k) => {
                if(moment(day.datum).format("DD-MM-YYYY") === moment(this.state.dateArray[column]).format("DD-MM-YYYY")) {
                    this.props.leitstandSortierung.data.umlaufplaene_aktiv[k].wert = ""
                }
            })
            this.props.dienstplanSoll({datum: moment(this.state.dateArray[column]).add(5, "hours"), wert: ""})
            return
        }

        var dienst = this.getValue(column, row)
        if(dienst !== undefined
            && dienst.name !== ""
            && this.state.dienste
            && this.state.dienste[dienst.mitarbeiter]
            && this.state.dienste[dienst.mitarbeiter][dienst.date]
        ) {
            this.cell_setValue(column)
            delete this.state.entries[column][row]
            delete this.state.dienste[dienst.mitarbeiter][dienst.date]
            this.props.deleteDienst(dienst.id)
            this.setState({})
        }
    }

    rowBorder = (key) => {
        var borderBold = false
        if(this.props.leitstandSortierung.data.objekte && this.props.leitstandSortierung.data.objekte[key]) {
            borderBold = !this.props.leitstandSortierung.data.objekte[key].border
        }
        this.state.borderBold = {row: key, border: borderBold}
        this.onRowsReordered()
    }

    contextMenu = (val) => {
        
        var column = val.target.cols[0]
        var row = val.target.rows[0]
        var dienst = this.getValue(column, row)

        var umlaufplan = []
        umlaufplan.push(dienst.paket)
        umlaufplan.push(dienst.kuerzel + ", " + dienst.raw_name)
        umlaufplan.push(dienst.start)
        umlaufplan.push(dienst.ende)

        var menuItems = []

        if(dienst && dienst.umlaufplan) { 
            menuItems.push(<MenuItem onClick={() => this.props.printDienstplan({mitarbeiter: dienst.mitarbeiter, von: moment(dienst.datum).format("YYYY-MM-DD"), bis: moment(dienst.datum).format("YYYY-MM-DD")})} icon="eye-open" text={umlaufplan.join(" ")+" = " + dienst.stunden} />)
            menuItems.push(<MenuItem onClick={() => this.props.printDienstplan({mitarbeiter: dienst.mitarbeiter, von: moment(dienst.datum).format("YYYY-MM-DD"), bis: moment(dienst.datum).format("YYYY-MM-DD"), small: true})} icon="eye-open" text={"SMALL:" +umlaufplan.join(" ")+" = " + dienst.stunden} />)
            menuItems.push(<MenuItem onClick={() => this.deleteItem(column, row)} icon="delete" text="Eintrag löschen" />)
            menuItems.push(<Divider />)
        }

        if(dienst !== undefined) {
            menuItems.push(<MenuItem onClick={() => this.showAnmerkung(dienst.id)} icon="annotation" text={"Anmerkung"} />)
            menuItems.push(<Divider />)
        }
        
        menuItems.push(<MenuItem onClick={() => this.rowBorder(row)} icon="new-link" text={"Trennlinie"} />)

        return(
            <Menu>
                {menuItems}
            </Menu>
        )

    } 

    showUmlaufplan = (umlaufplan) => {
        this.setState({
            dialogOpen: true,
            umlaufplan: umlaufplan
        })
    }


    month_now = () => {
        this.state.newEntry = {}
        this.state.startDate = moment().startOf('month')
        this.state.endDate = moment().endOf('month')
        this.state.tmpMonth = moment()
        this.calcDays()
    }


    month_change = (direction) => {
        this.state.newEntry = {}
        this.state.dienstplanAuswahl = undefined

        var tmpMonth = _.clone(this.state.tmpMonth)
        if(!direction) {
            this.state.tmpMonth = tmpMonth.subtract(1, 'months')
        } else {
            this.state.tmpMonth = tmpMonth.add(1, 'months')
        }

        this.state.startDate = moment(this.state.tmpMonth).startOf('month')
        this.state.endDate = moment(this.state.tmpMonth).endOf('month')
        
        this.calcDays()
    }

    onRowsReordered = (oldIndex: number, newIndex: number, length: number, doReorder: bool) => {
        ////console.log(oldIndex, newIndex, length)
        
        var mitarbeiter = this.props.mitarbeiter.data
        var newIdx = mitarbeiter[parseInt(oldIndex)]

        this.props.mitarbeiter.data = mitarbeiter
        this.setState({})

        var mitarbeiterTmp = []
        mitarbeiter.forEach((item, key) => {
            if(key === oldIndex) {
                return
            }
            if(newIndex < oldIndex && key === newIndex) {
                mitarbeiterTmp.push(newIdx)
            }
            mitarbeiterTmp.push(item)
            if(newIndex > oldIndex && key === newIndex) {
                mitarbeiterTmp.push(newIdx)
            }
        })

        mitarbeiter = mitarbeiterTmp
        this.props.mitarbeiter.data = mitarbeiter

        var order = []
        mitarbeiter.forEach((item, key) => {
            var borderBold = false
            if(this.props.leitstandSortierung.data.objekte && this.props.leitstandSortierung.data.objekte[key]) {
                borderBold = this.props.leitstandSortierung.data.objekte[key].border
            }
            if(this.state.borderBold && key === this.state.borderBold.row) {
                borderBold = this.state.borderBold.border
            }
            order.push({
                object_id: item.id,
                typ: "mitarbeiter",
                sort: parseInt(key),
                border: borderBold
            })
        })

        this.props.mitarbeiter.data = mitarbeiter
        var d = this.state.startDate.toDate();

        var data = {
            ...this.props.leitstandSortierung.data,
            monat: d.getMonth() + 1,
            jahr: d.getFullYear(),
            objekte: order
        }

        this.state.borderBold = undefined

        if(this.props.leitstandSortierung.data.id) {
            this.props.leitstandSortierung_doPut(this.props.leitstandSortierung.data.id, data)
        } else {
            this.props.leitstandSortierung_postData(data)
        }

    }

    searchUmlaufplan = (query, event) => {
        if(query === "") {
            return
        }
        this.setState({query: query})
        this.props.umlaufplan_doLoad({s: query, datum: moment(this.state.datum).format("YYYY-MM-DD")})
    }

    omnibarItem = (item, { handleClick, modifiers, query }) => {
        return <MenuItem
            active={modifiers.active}
            disabled={modifiers.disabled}
            label={<span>{item.start} - {item.ende} / {convertMinutesToString(item.netto_zeit)}</span>}
            key={item.key}
            onClick={handleClick}
            text={
                <div>
                    <div className="miniFarbe" style={{marginRight: 10, backgroundColor: item.farbe}}></div>
                    {item.paket} <b>{item.kuerzel_bus}</b> - {item.kuerzel} - {item.name}
                </div>
            }
        />
    }

    onItemSelect = (item, event) => {
        this.selectUmlaufplan(item)
        this.setState({dialogOpen_umlaufplan:false})
    }

    setInputRef = (ref) => {
        return ref.focus()

    }

    deleteNode = () => {
        var text = "Soll der Eintrag gelöscht werden?"
        if(this.state.selectedFields.col_f !== this.state.selectedFields.col_t) {
            text = "Sollen die Einträge gelöscht werden!"
        }
        if(window.confirm(text)) {
            if(this.state.selectedFields.col_f !== this.state.selectedFields.col_t) {
                var i = this.state.selectedFields.col_f
                while(i<=this.state.selectedFields.col_t) {
                    this.deleteItem(i, this.state.selectedFields.row)
                    i++;
                }
            } else {
                this.deleteItem(this.state.selectedCell.col, this.state.selectedCell.row)
            }
        }
    }

    selectedCell = (cell) => {
        this.state.selectedCell = cell
    }

    _saveAction = () => {
        var month = moment(this.state.startDate).format("MM")
        var year = moment(this.state.startDate).format("YYYY")
        this.state.newEntry.jahr = parseInt(year)
        this.state.newEntry.monat = parseInt(month)
        this.props.leitstandAttribute_postData(this.state.newEntry)
    }

    showAnmerkung = (id) => {
        var dienst = {}
        this.props.dienst.data.forEach((_dienst) => {
            if(_dienst.id === id) {
                dienst = _dienst
            }
        })
        this.setState({
            anmerkung_text: dienst.kommentar,
            anmerkung_dienst: id,
            anmerkung_show: true
        })
    }

    handleCloseAnmerkung = () => {
        this.setState({
            anmerkung_text: "",
            anmerkung_dienst: undefined,
            anmerkung_show: false
        })
    }

    handleSaveAnmerkung = () => {
        var dienst = {}
        this.props.dienst.data.forEach((_dienst) => {
            if(_dienst.id === this.state.anmerkung_dienst) {
                dienst = _dienst
            }
        })
        dienst.kommentar = this.state.anmerkung_text
        this.props.putDienst(dienst, dienst.id)
        this.handleCloseAnmerkung()
    }

    handleChangeAnmerkung = name => event => {
        this.setState({
            [name]: event.target.value
        })
    }

    selectedFields = (fields) => {
        this.state.selectedFields = fields
    }

    appendToCopyData = (rowIndex, columnIndex, val) => {
        if(!this.state.copyData[rowIndex]) {
            this.state.copyData[rowIndex] = []
        }
        if(!this.state.copyData[rowIndex][columnIndex]) {
            this.state.copyData[rowIndex][columnIndex] = ""
        }
        this.state.copyData[rowIndex][columnIndex] = val
    }

    dienstplanAuswahl = (val) => {

        var res = val.target.value.split("-")
        var tmpDate = new Date(parseInt(res[0]), parseInt(res[1])-1, 1, 1, 1, 1, 1, 1)
        this.state.tmpMonth = moment(tmpDate)
        //console.log("his.state.tmpMonth", this.state.tmpMonth)

        this.state.startDate = moment(this.state.tmpMonth).startOf('month')
        this.state.endDate = moment(this.state.tmpMonth).endOf('month')
        
        this.state.dienstplanAuswahl = val.target.value

        this.calcDays()
    } 
 
    render() {

        var { classes, mitarbeiter, dienst, leitstandSortierung, umlaufplan } = this.props
        var { newEntry, isLoading, dialogOpen, newEntry, daysArray, dateArray, dialogOpen_umlaufplan, startDate, endDate, prevMonth, nextMonth, dienste, weekArray, newEntry, anmerkung_show, anmerkung_dienst, anmerkung_text } = this.state

        var {
            text1,
            text2,
            info
        } = newEntry

        var showLoader = false
        if(mitarbeiter.isLoading || dienst.isLoading || leitstandSortierung.isLoading || umlaufplan.isLoading) {
            showLoader = true
        }

        var kalender = {}
        if(leitstandSortierung.data && leitstandSortierung.data.kalender) {
            leitstandSortierung.data.kalender.forEach((entry) => {
                kalender[moment(entry.datum).format("dd,DD")] = entry.name
            })
        }

        var widths = new Array(daysArray.length+1).fill(26)
        widths[0] = 200
        widths.push(60) // Busnummer
        widths.push(60) // Stunden AZ
        widths.push(60) // Stunden AZ Gesamt
        widths.push(40) // Anzahl Dienste
        var stundenWidth = widths.length
        weekArray.forEach((week) => {
            widths.push(40)
        })

        const cellRendererWeek = (rowIndex, columnIndex) => {

            var valueWochenstunden = 0
            if(this.props.wochenstunden) {
                valueWochenstunden = parseFloat(this.props.wochenstunden.value)
            }

            if(mitarbeiter && mitarbeiter.data[rowIndex] !== undefined) {
                var mitarbeiterId = mitarbeiter.data[rowIndex].id
                var key = columnIndex - stundenWidth + 1
                var weekNr = weekArray[key]
                var borderBold = {}
                if( this.props.leitstandSortierung.data && this.props.leitstandSortierung.data.objekte && this.props.leitstandSortierung.data.objekte[rowIndex]) {
                    if(this.props.leitstandSortierung.data.objekte[rowIndex].border) {
                        borderBold = {borderBottom: "solid 2px black"}
                    }
                }
                key = parseInt(weekArray[key-1])
                if(this.state.kwZeit[mitarbeiterId] && this.state.kwZeit[mitarbeiterId][key]) {
                    
                    var wert = (parseInt(this.state.kwZeit[mitarbeiterId][key])/60).toFixed(1)
                    var color = {}
                    if(wert > valueWochenstunden) {
                        color = {background: "rgb(239,193,191)"}
                    }
                    this.appendToCopyData(rowIndex, columnIndex, wert)
                    return <Cell style={{textAlign: "center", justifyContent: "center", ...borderBold, ...color}}>
                        {wert}
                    </Cell>
                }
                return <Cell style={{textAlign: "center", justifyContent: "center", ...borderBold}} />
            }
            return <Cell></Cell>
        }

        const cellRendererZeit = (rowIndex, columnIndex) => {

            var col_busnummer       = stundenWidth - 4
            var col_stundenAz       = stundenWidth - 3
            var col_stundenAzGesamt = stundenWidth - 2
            var col_anzahl          = stundenWidth - 1

            if(mitarbeiter && mitarbeiter.data[rowIndex] !== undefined) {
                var borderBold = {}
                if( this.props.leitstandSortierung.data && this.props.leitstandSortierung.data.objekte && this.props.leitstandSortierung.data.objekte[rowIndex]) {
                    if(this.props.leitstandSortierung.data.objekte[rowIndex].border) {
                        borderBold = {borderBottom: "solid 2px black"}
                    }
                }
                if(columnIndex == col_busnummer) {
                    var _mitTmp = mitarbeiter.data[rowIndex];
                    var val = ""
                    if(this.props.leitstandSortierung.data.dienstplan_busnummer) {
                        this.props.leitstandSortierung.data.dienstplan_busnummer.forEach((item) => {
                            if(item.mitarbeiter_id === _mitTmp.id) {
                                val = item.wert
                            }
                        })
                    }
                    var value = val === undefined || val === "" ? "" : val
                    this.appendToCopyData(rowIndex, columnIndex, value)
                    return <EditableCell
                        style={{textAlign: "center", justifyContent: "center", ...borderBold}}
                        onConfirm={(value) => this.cell_onConfirm_Busnummer(value, _mitTmp.id, rowIndex)}
                        value={value}
                    />
                }
                if(columnIndex == col_stundenAz) {
                    var _mitTmp = mitarbeiter.data[rowIndex];
                    if(this.state.nettoZeit[_mitTmp.id]) {
                        var value = (parseFloat(this.state.nettoZeit[_mitTmp.id])/60).toFixed(1)
                        this.appendToCopyData(rowIndex, columnIndex, value)
                        return <Cell style={{...borderBold, textAlign: "right", justifyContent: "flex-end"}}>{value}</Cell>
                    }
                    return <Cell style={{...borderBold}}></Cell>
                }
                if(columnIndex == col_stundenAzGesamt) {
                    var _mitTmp = mitarbeiter.data[rowIndex];
                    if(this.state.nettoZeitGesamt[_mitTmp.id]) {
                        var value = (parseFloat(this.state.nettoZeitGesamt[_mitTmp.id])/60).toFixed(1)
                        this.appendToCopyData(rowIndex, columnIndex, value)
                        return <Cell style={{...borderBold, textAlign: "right", justifyContent: "flex-end"}}>{value}</Cell>
                    }
                    return <Cell style={{...borderBold}}></Cell>
                }
                if(columnIndex == col_anzahl) {
                    var _mitTmp = mitarbeiter.data[rowIndex];
                    if(this.state.diensteAnzahl && this.state.diensteAnzahl[_mitTmp.id]) {
                        var value = parseInt(this.state.diensteAnzahl[_mitTmp.id])
                        this.appendToCopyData(rowIndex, columnIndex, value)
                        return <Cell style={{...borderBold, textAlign: "right", justifyContent: "flex-end"}}>{value}</Cell>
                    }
                    return <Cell style={{...borderBold}}></Cell>
                }
            }

            if(mitarbeiter.data.length + 1 < rowIndex && columnIndex == col_stundenAz) {
                var zeitGesamt = 0.0
                Object.keys(this.state.nettoZeit).forEach((key) => {
                    var value = this.state.nettoZeit[key]
                    zeitGesamt += parseFloat((parseInt(value)/60).toFixed(1))
                })
                var value = zeitGesamt.toFixed(1)
                this.appendToCopyData(rowIndex, columnIndex, value)
                return <Cell style={{textAlign: "right", justifyContent: "flex-end"}}>{value}</Cell>
            }

            if(mitarbeiter.data.length + 1 < rowIndex && columnIndex == col_stundenAzGesamt) {
                var zeitGesamt = 0.0
                Object.keys(this.state.nettoZeitGesamt).forEach((key) => {
                    var value = this.state.nettoZeitGesamt[key]
                    zeitGesamt += parseFloat((parseInt(value)/60).toFixed(1))
                })
                this.appendToCopyData(rowIndex, columnIndex, value)
                var value = zeitGesamt.toFixed(1)
                return <Cell style={{textAlign: "right", justifyContent: "flex-end"}}>{value}</Cell>
            }

            if(this.state.diensteAnzahl && mitarbeiter.data.length + 1 < rowIndex && columnIndex == col_anzahl) {
                var anzahl = 0.0
                Object.keys(this.state.diensteAnzahl).forEach((key) => {
                    anzahl += parseInt(this.state.diensteAnzahl[key])
                })
                this.appendToCopyData(rowIndex, columnIndex, anzahl)
                return <Cell style={{textAlign: "right", justifyContent: "flex-end"}}>{anzahl}</Cell>
            }

            this.appendToCopyData(rowIndex, columnIndex, "")
            return <Cell></Cell>

        }

        const cellRenderer = (rowIndex, columnIndex) => {

            var borderBold = {}
            if( this.props.leitstandSortierung.data && this.props.leitstandSortierung.data.objekte && this.props.leitstandSortierung.data.objekte[rowIndex]) {
                if(this.props.leitstandSortierung.data.objekte[rowIndex].border) {
                    borderBold = {borderBottom: "solid 2px black"}
                }
            }

            var isFeiertag = false
            if(daysArray[columnIndex]) {
                var day = daysArray[columnIndex]
                if(kalender[day]) {
                    isFeiertag = true
                }
            }

            var day = rowIndex
            if(daysArray[columnIndex] !== undefined) {
                day = daysArray[columnIndex].split(",")
            }
            
            if(columnIndex === 0 && rowIndex <= mitarbeiter.data.length) {
                if(mitarbeiter.data[rowIndex] === undefined) {
                    return <Cell style={{...borderBold}}></Cell>
                }
                var name = mitarbeiter.data[rowIndex].familienname + " " + mitarbeiter.data[rowIndex].name
                this.appendToCopyData(rowIndex, columnIndex, name)
                return <Cell style={{...borderBold}}>{name}</Cell>
            }

            var stat_diensteIst = mitarbeiter.data.length+1
            var stat_diensteSoll = mitarbeiter.data.length+2

            if(columnIndex === 0 && rowIndex > mitarbeiter.data.length) {
                if(stat_diensteIst === rowIndex) {
                    this.appendToCopyData(rowIndex, columnIndex, "Dienste IST")
                    return <Cell>Dienste&nbsp;<b>IST</b></Cell>
                }
                if(stat_diensteSoll === rowIndex) {
                    this.appendToCopyData(rowIndex, columnIndex, "Dienste SOLL")
                    return <Cell>Dienste&nbsp;<b>SOLL</b></Cell>
                }
            }

            var value = this.getValue(columnIndex, rowIndex)
            var name = ""
            var name_ist = undefined
            var name_soll = ""
            if(value.name && value.start !== undefined) {
                name_soll = value.paket + " " + value.kuerzel + " " + value.raw_name + ": " + value.start + " - " + value.ende + " = " + value.stunden
                name_ist = value.ist_start + " - " + value.ist_ende + " = " + convertMinutesToString(value.ist_stunden)
                if(name_soll===name_ist) {
                    name_ist = undefined
                }
                name = name_soll
            } else {
                if(value.stunden) {
                    name = value.name + " - " + value.stunden
                } else {
                    name = value.name
                }
            }

            if(value.name === "FT") {
                value.name = ""
            }
            
            var farbe = ""
            if(day[0] === "So") {
                farbe = "#cccccc"
            }

            if(isFeiertag) {
                farbe = "#cccccc"
            }

            if(value && value.farbe) {
                farbe = value.farbe
            }

            if(farbe === "#ffffff" || farbe === "#fff") {
                farbe = ""
            }

            var fontSize = 10
            if(parseInt(value.name) > 0) {
                fontSize = 12
            }

            if(rowIndex > mitarbeiter.data.length) {
                fontSize = 12
                var val = ""
                if(stat_diensteIst === rowIndex) {
                    val = this.state.stat_diensteIst[day]
                }
                if(stat_diensteSoll === rowIndex) {
                    if(this.props.leitstandSortierung.data.umlaufplaene_aktiv && this.props.leitstandSortierung.data.umlaufplaene_aktiv[columnIndex-1]) {
                        val = this.props.leitstandSortierung.data.umlaufplaene_aktiv[columnIndex-1].wert
                    }
                }
                if(columnIndex > this.state.daysArray.length - 1) {
                    return <Cell></Cell>
                }
                var value = val === undefined || val === "" ? "" : val
                this.appendToCopyData(rowIndex, columnIndex, value)
                return <EditableCell
                    style={{textAlign: "center", justifyContent: "center"}}
                    onConfirm={(value) => this.cell_onConfirm_SOLL(value, columnIndex)}
                    value={value}
                />
            }

            var classes = "dienst"
            var derWert = <div />
            if(value && value.name) {
                derWert = (
                    <div className="hasKommentar">
                        {value.name}
                        <div className="kommentar">
                            {name && <div><b>SOLL:</b> {name}</div>}
                            {name_ist && <div><b>IST:</b> {name_ist}</div>}
                            {value.kommentar && <div>{value.kommentar}</div>}
                        </div>
                    </div>
                )
                if(value.kommentar) {
                    classes += " triangle"
                }
            } else {
                derWert = value.name
            }

            if(derWert === undefined) {
                derWert = ""
            }

            if((value.kuerzel+"").toLowerCase() === "ft") {
                derWert = ""
            }

            this.appendToCopyData(rowIndex, columnIndex, value.name)

            return (
                <EditableCell
                    className={classes}
                    style={{...borderBold, background: farbe, color: value.textFarbe, textAlign: "center", fontSize: fontSize}}
                    loading={value && value.isLoading}
                    onChange={(value) => this.cell_onChange(value, rowIndex, columnIndex)}
                    onConfirm={(value) => this.cell_onConfirm(value, rowIndex, columnIndex)}
                    value={derWert}
                />
            )
        }

        const renderColumnHeader = (columnIndex) => {
            var day = columnIndex
            var week = "00"
            if(daysArray[columnIndex] !== undefined) {
                day = daysArray[columnIndex].split(",")
                week = moment(dateArray[columnIndex]).format("ww")
            }

            var ext = {}
            var isFeiertag = false
            if(daysArray[columnIndex]) {
                var _day = daysArray[columnIndex]
                if(kalender[_day]) {
                    isFeiertag = true
                    ext = {
                        fontWeight: "bold",
                        background: "#cccccc"
                    }
                }
            }
            
            const nameRenderer = () => (
                <div className="leitstand-header">
                    {day[0] === "Mo" ? <div style={{height:"17px", fontWeight: "bold"}} className="weekHeader">{week}</div> : <div style={{height:"17px"}} className="weekHeader" />}
                    <div>{day[0]}</div>
                    <div className="small">{day[1]}</div>
                </div>
            )
            return <ColumnHeaderCell 
                enableColumnReordering={true}
                style={{textAlign: "center", fontSize: 10, ...ext}}
                name={day}
                nameRenderer={nameRenderer}
            />
        }

        const renderColumnHeaderMitarbeiter = (columnIndex) => {
            const nameRenderer = () => (
                <div className="leitstand-header">
                    <div style={{height:"17px"}} className="weekHeader" />
                    <div>&nbsp;</div>
                    <div className="small">Mitarbeiter</div>
                </div>
            )
            return <ColumnHeaderCell 
                enableColumnReordering={true}
                style={{textAlign: "center"}}
                nameRenderer={nameRenderer}
            />
        }

        const renderColumnHeaderWeek = (columnIndex) => {
            var key = columnIndex - stundenWidth
            return <ColumnHeaderCell>
                <div className="leitstand-header">
                    <div>KW</div>
                    <div className="small">{weekArray[key]}</div>
                </div>
            </ColumnHeaderCell>
        }

        const renderColumnHeaderZeit = (columnIndex) => {
            const nameRenderer = () => {
                if(columnIndex == stundenWidth - 4) {
                    return <div style={{textAlign: "right"}}>
                        <div class="leitstand-header"><b>Busnr.</b></div>
                    </div>
                }
                if(columnIndex == stundenWidth - 3) {
                    return <div style={{textAlign: "right"}}>
                        <div class="leitstand-header"><div><b>Stunden</b></div><div class="small">AZ</div></div>
                    </div>
                }
                if(columnIndex == stundenWidth - 2) {
                    return <div style={{textAlign: "right"}}>
                        <div class="leitstand-header"><div><b>Stunden</b></div><div class="small">AZ (alle)</div></div>
                    </div>
                }
                if(columnIndex == stundenWidth - 1) {
                    return <div style={{textAlign: "right"}}>
                        <div class="leitstand-header"><div><b>Anz.</b></div><div class="small">Dienst</div></div>
                    </div>
                }
                return <div />
            }
            return <ColumnHeaderCell 
                enableColumnReordering={true}
                style={{textAlign: "right"}}
                nameRenderer={nameRenderer}
            />
        }


        var {
            rowIndex,
            columnIndex,
            datum,
            dialogOpen_umlaufplan,
            query
        } = this.state

        var omnibarItems = []

        const handlers = {
            'deleteNode': this.deleteNode
        }

        //console.log("leitstandSortierung.data", leitstandSortierung.data)

        return (
            <div>

                <RAW_Dialog fullWidth={true} maxWidth="sm" open={anmerkung_show} onClose={this.handleCloseAnmerkung} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Anmerkung</DialogTitle>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            multiline
                            fullWidth
                            value={anmerkung_text}
                            onChange={this.handleChangeAnmerkung("anmerkung_text")}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleCloseAnmerkung} color="primary">Abbrechen</Button>
                        <Button variant="contained" onClick={this.handleSaveAnmerkung} color="primary">Speichern</Button>
                    </DialogActions>
                </RAW_Dialog>

                <Omnibar
                    isOpen={dialogOpen_umlaufplan}
                    items={umlaufplan.data}
                    resetOnQuery={true}
                    noResults={<MenuItem disabled={true} text="Keine Umlaufpläne gefunden!" />}
                    onItemSelect={this.onItemSelect}
                    resetOnSelect={true}
                    query={query}
                    onClose={() => this.setState({dialogOpen_umlaufplan: false, query: ""})}
                    onQueryChange={this.searchUmlaufplan}
                    itemRenderer={this.omnibarItem}
                    inputProps={{inputRef: input => input && input.focus()}}
                />

                <div className="header">

                    <Paper>
                        <Grid container spacing={8} className="leitstand-datum">

                            <Grid item xs={1}>
                                {leitstandSortierung.data && leitstandSortierung.data.dienstplaene && <Select_RAW
                                    fullWidth
                                    value={this.state.dienstplanAuswahl}
                                    onChange={this.dienstplanAuswahl}
                                >
                                    {leitstandSortierung.data.dienstplaene.map((plan) => {
                                        return <MenuItem_RAW className="menuItem" value={plan.jahr+"-"+plan.monat}>{plan.jahr} / {plan.monat} /&nbsp;<b>{moment().month(plan.monat-1).format("MMMM")}</b></MenuItem_RAW>
                                    })}
                                </Select_RAW>}
                            </Grid>

                            <Grid item xs={1} style={{display:'none'}}>
                                <DatePickerContainer
                                    dateInput
                                    name="startDate"
                                    label="Start"
                                    value={startDate}
                                    onChange={this.new_changeDate('startDate')}
                                />
                            </Grid>
                            <Grid item xs={1} style={{display:'none'}}>
                                <DatePickerContainer
                                    dateInput
                                    label="Ende"
                                    value={endDate}
                                    name="endDate"
                                    onChange={this.new_changeDate('endDate')}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <Button onClick={() => this.month_change(false)}>- Monat</Button>
                                <Button onClick={this.month_now}>{moment().format("MMMM")}</Button>
                                <Button onClick={() => this.month_change(true)}>Monat +</Button>
                            </Grid>
                            <Grid item xs={4}>
                                <h3>
                                    {moment(startDate).isValid() && moment(startDate).format("MMMM YYYY")}
                                </h3>
                            </Grid>
                            <Grid item xs={4} className="text-right">
                                <ButtonGroup
                                    groupName={<div className="alignCenter"><PrintIcon  className="marginRight"/> Übersicht</div>}
                                    links={[
                                        {icon: <PrintIcon />, label: "Drucken", onClick: () => this.props.print(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))},
                                        {icon: <PdfIcon />, label: "Download", onClick: () => this.props.print_download(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))},
                                    ]}
                                />

                                <ButtonGroup
                                    groupName={<div className="alignCenter"><PrintIcon  className="marginRight"/> Leistand</div>}
                                    links={[
                                        {icon: <PrintIcon />, label: "Drucken", onClick: () => this.props.printExt(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))},
                                        {icon: <PdfIcon />, label: "Download", onClick: () => this.props.printExt_download(moment(startDate).format("YYYY-MM-DD"), moment(endDate).format("YYYY-MM-DD"))},
                                    ]}
                                />

                            </Grid>
                        </Grid>
                        {showLoader && <LinearProgress style={{width: "100%", position: "absolute", zIndex:9999}} />}
                    </Paper>

                </div>


                <HotKeys keyMap={map} handlers={handlers}>
                    <Dienstplan

                        getSingleData={this.getCellClipboardData}
                        doFocus={this.state.dialogOpen_umlaufplan}
                        kalender={Object.keys(kalender).length}
                        contextMenu={this.contextMenu}
                        widths={widths}
                        mitarbeiter={mitarbeiter}
                        renderColumnHeaderMitarbeiter={renderColumnHeaderMitarbeiter}
                        renderColumnHeaderZeit={renderColumnHeaderZeit}
                        daysArray={daysArray}
                        dateArray={dateArray}
                        weekArray={weekArray}
                        renderColumnHeader={renderColumnHeader}
                        cellRenderer={cellRenderer}
                        cellRendererZeit={cellRendererZeit}

                        renderColumnHeaderWeek={renderColumnHeaderWeek}
                        cellRendererWeek={cellRendererWeek}

                        onRowsReordered={this.onRowsReordered}
                        selectedCell={this.selectedCell}
                        dienste={Object.keys(dienst.data).length}
                        sortierung={this.props.leitstandSortierung.data.objekte}
                        umlaufplaeneAktiv={this.props.leitstandSortierung.data.umlaufplaene_aktiv}
                        dienstplanBusnummer={this.props.leitstandSortierung.data.dienstplan_busnummer}
                        kwZeit={this.state.kwZeit}
                        selectedFields={this.selectedFields}

                    />   
                </HotKeys>

                <Card className="marginTop">
                    <CardContent>
                        <Grid container spacing={8}>
                            <TextFieldHelper multiline value={text1} onChange={this.handleChange('text1')} n={6} label="Textfeld 1" />
                            <TextFieldHelper multiline value={text2} onChange={this.handleChange('text2')} n={6} label="Textfeld 2" />
                            <TextFieldHelper multiline value={info} onChange={this.handleChange('info')} n={12} label="Info Dienstplanübersicht" />
                        </Grid>
                    </CardContent>
                    <CardActions>
                        <LoaderButton icon="save" name="Speichern" color="primary" onClick={this._saveAction} loading={this.state.putLoading} />
                    </CardActions>
                </Card>

            </div>
        )
    }

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
    mitarbeiter: state.mitarbeiter,
    leitstandSortierung: state.leitstandSortierung,
    umlaufplan: state.umlaufplan,
    besondererDienst: state.besondererDienst,
    wochenstunden: state.parameter.data
})

const mapDispatchToProps = (dispatch, ownProps) => ({

    parameter_doLoad: () => dispatch(doLoad("parameter", "api/generic/parameter/single/wochenstunden", {})),

    mitarbeiter_doLoad: (filter) => dispatch(doLoad("mitarbeiter", "api/generic/mitarbeiter/list", filter)),
    doLoad: (filter) => dispatch(doLoad(ENDPOINT, "api/generic/"+ENDPOINT+"/list", filter)),
    besondererDienst_doLoad: (filter) => dispatch(doLoad("besondererDienst", "api/generic/besondererDienst/list", filter)),

    leitstandSortierung_doLoad: (filter) => dispatch(doLoad("leitstandSortierung", "api/generic/leitstandSortierung/list", filter)),
    leitstandSortierung_postData: (data) => dispatch(doPost("leitstandSortierung", "api/generic/leitstandSortierung", data, undefined, true)),
    leitstandSortierung_doPut: (id, data) => dispatch(doPut("leitstandSortierung", "api/generic/leitstandSortierung/"+id, data)),
   
    postDienst: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data, undefined, undefined, true)),
    putDienst: (data, id) => dispatch(doPut("generic", "api/generic/" + ENDPOINT + "/" + id, data)),

    leitstandAttribute_postData: (data) => dispatch(doPost("generic", "api/generic/leitstandAttribute", data, undefined, true)),

    dienstplanSoll: (data) => dispatch(doPost("dienstplanSoll", "api/generic/dienstplanSoll", data)),
    dienstplanBusnummer: (data) => dispatch(doPost("dienstplanBusnummer", "api/generic/dienstplanBusnummer", data)),

    deleteDienst: (id) => dispatch(doDelete(ENDPOINT, "api/generic/"+ENDPOINT+"/"+id, id)),

    umlaufplan_doLoad: (filter) => dispatch(doLoad("umlaufplan", "api/generic/umlaufplan/list", filter)),

    print: (start, ende) => dispatch(apiUrlOpen("api/pdf/leitstand/leitstand.pdf", "&von="+start+"&bis="+ende, true)),
    print_download: (start, ende) => dispatch(apiUrlOpen("api/pdf/leitstand/leitstand.pdf", "&von="+start+"&bis="+ende, false)),

    printExt: (start, ende) => dispatch(apiUrlOpen("api/pdf/leitstand/leitstand.pdf", "&von="+start+"&bis="+ende+"&ext=1", true)),
    printExt_download: (start, ende) => dispatch(apiUrlOpen("api/pdf/leitstand/leitstand.pdf", "&von="+start+"&bis="+ende+"&ext=1", false)),

    printDienstplan: (filter) => dispatch(apiUrlOpen("api/pdf/umlaufplan/umlaufplan.pdf", filter, true)),

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ListObject));



// WEBPACK FOOTER //
// ./src/Routes/Dienstplan/index.js